import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)
const state = {
  collapsed: false,
  topNavState: 'home',
  // leftNavState: 'home'
}
const store = new Vuex.Store({
  modules: {
    user
  },
  state,
  //getters
})
/*从本地存储读取数据*/
// for(var item in state) {
//   localStorage.getItem(item)? state[item] = JSON.parse(localStorage.getItem(item)): false;
//   console.log(state[item])
// }
export default store



// WEBPACK FOOTER //
// ./src/store/index.js